export const getLangFromRouter = (match) => {
  return match?.params.lang?.replace('lang-', '') || 'en'
}